import { computed } from "vue";
import { EIconButtonElements } from "../types.js";
import useCreateComponentConfig, { EStates, EVariants } from "../../../composables/useCreateComponentConfig.js";
import focus from "../../constants/focus.js";
import { SIZES } from "@/ui/ts/types/Sizes";
export function useIconButtonConfig(props) {
  const { setBase, addSize, setDefault, getClasses, addVariant } = useCreateComponentConfig();
  setBase(
    EIconButtonElements.ROOT,
    `!font-display border-neutral-strong-on-dark border-radius-button 
    disabled:text-disabled disabled:bg-disabled disabled:border-disabled 
    border-radius-button override
    dark:dark active:bg-comp-accent-pressed flex items-center justify-center
    rounded-full border-2 transition-colors
    delay-0 duration-200 ease-linear ${focus}`
  );
  addSize(EIconButtonElements.ROOT, SIZES.XSMALL, "h-medium w-medium");
  addSize(EIconButtonElements.ROOT, SIZES.SMALL, "h-xl w-xl");
  addSize(EIconButtonElements.ROOT, SIZES.MEDIUM, "h-2xl w-2xl");
  addSize(EIconButtonElements.ROOT, SIZES.LARGE, "h-3xl w-3xl");
  addVariant(EIconButtonElements.ROOT, EVariants.PRIMARY, {
    base: "",
    states: {
      [EStates.DEFAULT]: `text-comp-high-contrast-invert bg-neutral-primary-invert border-neutral-strong-on-dark 
            active:bg-comp-invert-pressed active:text-brand-accent
            hover:text-brand-accent hover:bg-comp-invert-hover`
    }
  });
  addVariant(EIconButtonElements.ROOT, EVariants.SECONDARY, {
    base: "",
    states: {
      [EStates.DEFAULT]: `text-comp-high-contrast bg-comp-ghost border-neutral-strong
            active:bg-comp-ghost-pressed
        hover:bg-comp-ghost-hover`
    }
  });
  addVariant(EIconButtonElements.ROOT, EVariants.TERTIARY, {
    base: "",
    states: {
      [EStates.DEFAULT]: `bg-neutral-secondary text-comp-high-contrast active:bg-comp-secondary-pressed 
                    hover:bg-comp-secondary-hover border-transparent disabled:border-none`
    }
  });
  addVariant(EIconButtonElements.ROOT, EVariants.PLAIN, {
    base: "",
    states: {
      [EStates.DEFAULT]: `text-comp-high-contrast bg-comp-ghost active:bg-comp-ghost-pressed
            hover:bg-comp-ghost-hover border-transparent
            disabled:border-none`
    }
  });
  addVariant(EIconButtonElements.ROOT, EVariants.CAROUSEL, {
    base: "",
    states: {
      [EStates.DEFAULT]: (
        /* tw */
        `text-comp-high-contrast bg-neutral-primary-elevated hover:bg-comp-primary-elevated-hover active:bg-comp-primary-elevated-pressed 
            shadow-default-below border-none`
      )
    }
  });
  setDefault(EIconButtonElements.ROOT, EVariants.PRIMARY, SIZES.MEDIUM);
  const rootClasses = computed(() => {
    return getClasses(EIconButtonElements.ROOT, props.variant, props.size, EStates.DEFAULT);
  });
  return {
    rootClasses: rootClasses.value
  };
}
